"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoSaveStatus = void 0;
const react_1 = require("react");
const AutoSaveStatusProvider_1 = require("./AutoSaveStatusProvider");
/**
 * Provides access to the current auto-save status, i.e. idle/saving/done.
 *
 * Applications should generally instrument their network layer, i.e. GraphQL
 * mutations, to automatically update the auto-save status on any wire call,
 * and then just use this `useAutoSaveStatus` to "show spinners" in appropriate
 * places.
 *
 * See the `apolloHooks.ts` file in `internal-frontend` for an example.
 */
function useAutoSaveStatus() {
    return (0, react_1.useContext)(AutoSaveStatusProvider_1.AutoSaveStatusContext);
}
exports.useAutoSaveStatus = useAutoSaveStatus;
